import { render, staticRenderFns } from "./FloatingContact.vue?vue&type=template&id=2d9d67cc&scoped=true"
import script from "./FloatingContact.vue?vue&type=script&lang=js"
export * from "./FloatingContact.vue?vue&type=script&lang=js"
import style0 from "./FloatingContact.vue?vue&type=style&index=0&id=2d9d67cc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9d67cc",
  null
  
)

export default component.exports